export default __webpack_public_path__ + "static/media/Environment-01.807931da.jpg";